export const iconFontAwesomeHumanitarianVialVirus = (
	<i className="fa-solid fa-vial-virus"></i>
);
